import { validateGridSearch } from "@/components/composite/data-grid";
import { createFileRoute } from "@tanstack/react-router";
import { IdTypesPage } from "./-id-types/id-types.page";

export const Route = createFileRoute("/warehouse/id-types/")({
  validateSearch: validateGridSearch,
  component: IdTypesPage,
});
